<template>
  <div id="About" class="bg-color1" style="height:calc(100vh);">
    <div ref="app_head" class="col-12 lh40 bg-color-white b-s-2 pl5 pr5 fixed-t">
        <div class="col-3 f18" @click="$router.back(-1)"><i class="iconfont icon-31fanhui1 color-primary"></i></div>
        <div class="col-6 t-c color-primary"><span class="f24 fw">A</span>cerca</div>
        <div class="col-3 t-r f26"></div>
    </div>
    <div class="h4"></div>
    <div class="col-12 mt8 pl8 pr8">
      <div class="col-12 mt30 mb30 t-c">
        <img src="../../assets/pos.jpg" alt="" class="w10 r5">
      </div>
      <div class="col-12 t-c color-muted">
        Versión: {{$store.state.set.app_ver}}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'About',
  data () {
    return {
    }
  },
  created: function () {
  },
  methods: {
    save: function () {
      if(this.password != this.re_password || this.password == ''){
        return false;
      }
      let post_data = {}
      post_data.password = this.password
      this.post(this.api_url + 'Tec/account_safety_update',post_data,true).then((res)=>{
        if(res.status == 1){
          this.$store.commit('setAlert',{type:'success',msg: "Success"});
          this.$router.back(-1);
        }else{
          this.$store.commit('setAlert',{type:'error',msg: "Error"});
        }
      });
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/My/About.vue